// A page section on the signed-in pages: hairline above, a 16px title, a one-line hint, an action on the right.
// Kicker is the small Geist Mono caps label used above titles and inside trays.

import type { ReactNode } from 'react';

export function Kicker({ children }: { children: ReactNode }) {
  return <span className="kicker">{children}</span>;
}

export function Section({
  id,
  title,
  hint,
  action,
  danger,
  testid,
  children,
}: {
  id: string;
  title: string;
  hint?: ReactNode;
  action?: ReactNode;
  danger?: boolean;
  testid?: string;
  children?: ReactNode;
}) {
  return (
    <section className={`acct-sec${danger ? ' acct-danger' : ''}`} id={id} aria-labelledby={`${id}-title`} data-testid={testid}>
      <header className="acct-head">
        <div>
          <h2 id={`${id}-title`}>{title}</h2>
          {hint && <p>{hint}</p>}
        </div>
        {action}
      </header>
      {children}
    </section>
  );
}
